/* eslint-disable react/prop-types */
// /components/TextEffects/TextEffectFade.js
import React from 'react'
import './text-effects.css'

export const TextEffectFade = ({ children, duration = '1s', delay = '0s' }) => {
	return (
		<div
			className="we-text-fade"
			style={{ animationDuration: duration, animationDelay: delay }}
		>
			{children}
		</div>
	)
}
